<iahoy-modal-layout>
  <ng-container header-title>Hay cambios sin guardar</ng-container>
  <ng-container body>
    <p class="modal__text">
      Si sales de la página sin guardar los cambios, perderás todos los cambios que hayas realizado.<br />
      ¿Estás seguro de que quieres salir de esta página?
    </p>
  </ng-container>
  <ng-container actions>
    <iahoy-button type="button" variant="default" (click)="leavePage()">Salir de la página</iahoy-button>
    <iahoy-button type="button" variant="accent" (click)="stayOnPage()">Continuar en la página</iahoy-button>
  </ng-container>
</iahoy-modal-layout>
